import { FC } from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';
export interface CbNotificationBubbleProps extends BoxProps {
  variant?: 'lg';
  count?: number;
}
export const CbNotificationBubble: FC<CbNotificationBubbleProps> = ({
  count,
  variant,
  ...props
}) => {
  const bubblePadding = variant === 'lg' ? 1 : 0;
  const innerTextSize = variant !== 'lg' ? '10px' : '12px';
  const height = variant === 'lg' ? 'auto' : 4;
  if (!count) {
    return null;
  }
  return <Box height={height} width="auto" paddingY={bubblePadding} paddingX="0.40rem" borderRadius={50} {...props} data-sentry-element="Box" data-sentry-component="CbNotificationBubble" data-sentry-source-file="CbNotificationBubble.tsx">
      <Box position="relative" left="50%" transform="translateX(-50%)" data-sentry-element="Box" data-sentry-source-file="CbNotificationBubble.tsx">
        <Text lineHeight={height} textAlign="center" color="white" fontWeight={700} fontSize={innerTextSize} data-sentry-element="Text" data-sentry-source-file="CbNotificationBubble.tsx">
          {count > 99 ? '99+' : count}
        </Text>
      </Box>
    </Box>;
};